







import { auth, User } from 'firebase/app'
import Component from 'vue-class-component'
import footer from '@/modules/app/components/footer.vue'
import navbar from './navbar.vue'
import Vue from 'vue'

@Component({
  components: { appFooter: footer, navbar }
})
export default class App extends Vue {
  credentials = { username: '', password: '' }
  currentUser: any | null = null

  created () {
    auth().onAuthStateChanged(user => {
      this.currentUser = user
    })
  }
}

